// src/components/ui/card.jsx
import * as React from "react";
import { cn } from "./utils";

export function Card({ className, ...props }) {
  return <div className={cn("rounded-xl border bg-white shadow", className)} {...props} />;
}

export function CardHeader({ className, ...props }) {
  return <div className={cn("border-b p-4 font-semibold text-lg", className)} {...props} />;
}

export function CardTitle({ className, ...props }) {
  return <h3 className={cn("text-xl font-bold", className)} {...props} />;
}

export function CardContent({ className, ...props }) {
  return <div className={cn("p-6", className)} {...props} />;
}
